(function () {
  if (window.customElements.get('cart-shipping-bar')) return;

  class CartShippingBar extends HTMLElement {
    connectedCallback() {
      CartShippingBar.instances.add(this);
      if (CartShippingBar.lastCart) this.render(CartShippingBar.lastCart);
    }

    disconnectedCallback() {
      CartShippingBar.instances.delete(this);
    }

    render(cart) {
      const standard = parseInt(this.dataset.standard, 10) || -1;
      const fast = parseInt(this.dataset.fast, 10) || -1;
      const express = parseInt(this.dataset.express, 10) || -1;
      const style = this.dataset.style === '2' ? 2 : 1;
      const giftVariantId = this.dataset.giftVariantId ? parseInt(this.dataset.giftVariantId, 10) : null;
      const withCode = this.dataset.currencyWithCode === 'true';

      let shippingAmount = standard;
      if (standard > 0 && standard > fast && standard > express) {
        shippingAmount = standard;
      } else if (fast > 0 && fast > express) {
        shippingAmount = fast;
      } else if (express > 0) {
        shippingAmount = express;
      }
      if (!(shippingAmount > 0)) shippingAmount = standard > 0 ? standard : 500100;

      let total = 0;
      (cart.items || []).forEach((item) => {
        if (item.requires_shipping && item.variant_id !== giftVariantId) {
          total += item.original_line_price;
        }
      });

      const progress = Math.min(total / shippingAmount, 1);
      const standardPos = standard > 0 ? Math.min(standard / shippingAmount, 1) : 0;
      const fastPos = fast > 0 ? Math.min(fast / shippingAmount, 1) : 0;
      const expressPos = express > 0 ? Math.min(express / shippingAmount, 1) : 0;

      let milestone = standard;
      if (progress < standardPos) milestone = standard;
      else if (progress < fastPos) milestone = fast;
      else if (progress < expressPos) milestone = express;

      const remaining = Math.max(milestone - total, 0);
      const moneyStr = this.formatMoney(remaining, withCode);

      const messagesEl = this.querySelector('[data-shipping-bar-messages]');
      const messages = messagesEl ? JSON.parse(messagesEl.textContent) : {};

      let html = '';
      if (style === 1) {
        if (progress === 0) html = (messages.initial || '').replace('%%MONEY%%', moneyStr);
        else if (progress === 1) html = messages.style1_success || '';
        else html = (messages.style1_unreached || '').replace('%%MONEY%%', moneyStr);
      } else {
        if (progress === 0) html = (messages.initial || '').replace('%%MONEY%%', moneyStr);
        else if (progress < standardPos) html = (messages.style2_m1 || '').replace('%%MONEY%%', moneyStr);
        else if (progress < fastPos) html = (messages.style2_m2 || '').replace('%%MONEY%%', moneyStr);
        else if (progress < expressPos) html = (messages.style2_m3 || '').replace('%%MONEY%%', moneyStr);
        else html = messages.style2_success || '';
      }

      const msgEl = this.querySelector('[data-shipping-bar-msg]');
      if (msgEl) msgEl.innerHTML = html;

      const outerEl = this.querySelector('[data-shipping-bar-outer]');
      if (outerEl) {
        outerEl.classList.remove('is-intial', 'is-unreached', 'is-success', 'hdt-hidden');
        if (total <= 0) outerEl.classList.add('hdt-hidden');
        outerEl.classList.add(progress <= 0.7 ? 'is-intial' : progress === 1 ? 'is-success' : 'is-unreached');
      }

      const progressEl = this.querySelector('[data-shipping-bar-progress]');
      if (progressEl) {
        progressEl.dataset.hdtPercent = progress;
        progressEl.setAttribute('aria-valuenow', total);
      }

      const fillEl = this.querySelector('[data-shipping-bar-fill]');
      if (fillEl) fillEl.style.setProperty('--progress-rate', progress);
    }

    formatMoney(cents, withCode) {
      const format = withCode ? this.dataset.moneyWithCurrencyFormat : this.dataset.moneyFormat;
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
        return window.Shopify.formatMoney(cents, format);
      }
      return (cents / 100).toFixed(2);
    }
  }

  CartShippingBar.instances = new Set();
  CartShippingBar.lastCart = null;

  CartShippingBar.updateAll = function (cart) {
    CartShippingBar.lastCart = cart;
    CartShippingBar.instances.forEach((el) => el.render(cart));
  };

  window.customElements.define('cart-shipping-bar', CartShippingBar);

  // ---- Live-update on every cart mutation, on any page ----
  const CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  const isCartMutation = (url) => CART_ENDPOINTS.some((path) => url.includes(path));

  function refreshFromServer() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      .then((cart) => CartShippingBar.updateAll(cart))
      .catch(() => {});
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const req = args[0];
    const url = typeof req === 'string' ? req : req.url;
    const promise = originalFetch.apply(this, args);
    if (url && isCartMutation(url)) {
      promise.then((res) => {
        if (res.ok) refreshFromServer();
        return res;
      }).catch(() => {});
    }
    return promise;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (typeof url === 'string' && isCartMutation(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) refreshFromServer();
      });
    }
    return originalOpen.call(this, method, url, ...rest);
  };
})();